export default function DataBadge({ isReal, label }) {
  return (
    <span style={{
      fontSize: '10px',
      fontWeight: 600,
      padding: '2px 8px',
      borderRadius: '999px',
      background: isReal ? 'rgba(80,200,120,0.15)' : 'rgba(234,179,8,0.15)',
      color: isReal ? '#50C878' : '#eab308',
      marginLeft: '6px',
      verticalAlign: 'middle',
      whiteSpace: 'nowrap',
      display: 'inline-block',
    }}>
      {label || (isReal ? 'Live' : 'Taxminiy')}
    </span>
  );
}
